<script>
import NewForm from './New'

export default {
  mixins: [NewForm],
  methods: {
    load() {
      this.$http
        .get(`tdoc/bls/${this.$route.query.id}`)
        .then((res) => {
          this.bl = res.data
          this.$refs.form.resetValidation()
          if (!Boolean(this.$route.query.disabled)) {
            this.initPlacer()
          }
        })
        .catch((err) => {
          this.$message('', 'loadind画面に異常があります。')
        })
    },
    save() {
      this.setRequiredAndNextTick('formal', () => {
        if (!this.validateData()) return
        if (!this.validData()) return
        this.$http
          .put(`/tdoc/bls/${this.$route.query.id}/valid-md5`, this.bl)
          .then((res) => {
            if (res.data) {
              this.doSave()
            } else {
              this.$message(
                '',
                'BLデータはSAPから上書きされました、検索してから編集お願いします'
              )
            }
          })
          .catch((err) => {
            this.$message('', this.$t('app.system.error'))
          })
      })
    },
    doSave() {
      this.$http
        .put(`tdoc/bls/${this.$route.query.id}`, {
          ...this.bl,
          status: 'CONFIRMED',
        })
        .then(() => {
          this.load()
          this.$message('', '保存しました。')
        })
        .catch((err) => {
          if (this.$te(`tdoc.${err.response.data}`)) {
            this.$message('', this.$t(`tdoc.${err.response.data}`))
          } else {
            this.$message('', this.$t('app.system.error'))
          }
        })
    },
    tempSave() {
      if (this.bl.hasUpdated) {
        this.save()
      } else {
        this.setRequiredAndNextTick('temporary', () => {
          if (!this.validateData()) return
          if (!this.validTempData()) return
          this.$http
            .put(`/tdoc/bls/${this.$route.query.id}/valid-md5`, this.bl)
            .then((res) => {
              if (res.data) {
                this.doTempSave()
              } else {
                this.$message(
                  '',
                  'BLデータはSAPから上書きされました、検索してから編集お願いします'
                )
              }
            })
            .catch((err) => {
              this.$message('', this.$t('app.system.error'))
            })
        })
      }
    },
    doTempSave() {
      this.$http
        .put(`tdoc/bls/${this.$route.query.id}`, {
          ...this.bl,
          status: 'DRAFT',
        })
        .then(() => {
          this.load()
          this.$message('', '保存しました。')
        })
        .catch((err) => {
          if (this.$te(`tdoc.${err.response.data}`)) {
            this.$message('', this.$t(`tdoc.${err.response.data}`))
          } else {
            this.$message('', this.$t('app.system.error'))
          }
        })
    },
  },
  mounted() {
    console.log(this.$route.query.disabled)
    this.load()
  },
  watch: {},
}
</script>
